import { useState } from 'react';

import { MultiSelect, MultiSelectChangeEvent } from 'primereact/multiselect';

import { MIN_SEARCH_LENGTH } from '@/constants';
import { useSites } from '@/services/sites';

interface ISitesMultiSelectProps {
  className?: string;
  label?: string;
  value: string[];
  onChange: (sites: string[]) => void;
  disabled?: boolean;
  placeholder?: string;
  appendTo?: HTMLElement | null;
  optionLabel?: string;
  optionValue?: string;
}

export const SitesMultiSelect = ({
  className,
  label,
  value,
  onChange,
  disabled = false,
  placeholder = 'Select sites',
  appendTo,
}: ISitesMultiSelectProps) => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const { data: sites } = useSites({
    filter: 'search',
    search: searchTerm,
    ids: value,
  });

  const handleFilter = (event: { filter: string }) => {
    if (event.filter.length >= MIN_SEARCH_LENGTH) {
      setSearchTerm(event.filter);
    }
  };

  const handleChange = (e: MultiSelectChangeEvent) => {
    onChange?.(e.value);
  };

  return (
    <div className={`sites-multi-select ${className || ''}`}>
      {label && <label className="mb-2 block">{label}</label>}
      <MultiSelect
        value={value}
        options={sites || []}
        onChange={handleChange}
        optionLabel="name"
        optionValue="id"
        filter
        filterPlaceholder="Search sites..."
        onFilter={handleFilter}
        placeholder={placeholder}
        disabled={disabled}
        className="w-full"
        display="chip"
        appendTo={appendTo}
      />
    </div>
  );
};
